import { render, staticRenderFns } from "./BalanceDeposit.vue?vue&type=template&id=bc07f4be&"
import script from "./BalanceDeposit.vue?vue&type=script&lang=js&"
export * from "./BalanceDeposit.vue?vue&type=script&lang=js&"
import style0 from "./BalanceDeposit.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports